<div [hidden]="consulta">
  <div class="scroll-container">
    <dx-accordion #accordion [dataSource]="data" [collapsible]="true">
      <div *dxTemplate="let data of 'item'">
        <div *ngFor="let item of data.items; index as index">
          <p style="margin-bottom: 20px;">{{index + 1}}.-{{ item.respuestaabierta }}</p>
        </div>
      </div>
    </dx-accordion>
  </div>
</div>
